import "@angular/compiler";
import { environment } from "@env/environment";

import {
  enableProdMode,
  CSP_NONCE,
  provideZoneChangeDetection,
} from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "@app/app.module";

if (environment.production) {
  enableProdMode();
}

const nonce =
  (document.querySelector('meta[id="csp-nonce"]') as HTMLMetaElement)
    ?.content ?? "";

platformBrowserDynamic([{ provide: CSP_NONCE, useValue: nonce }])
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((_error) => console.error("error"));